/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 2. RdSAP Energy Performance Certificate 3. Full SAP Energy Performance Certificate 4. Interim RdSAP Energy Performance Certificate (to be superseded by SAP EPC) 
 */
export type ReportTypeCodeUIDTOV0 = '2' | '3' | '4';

export const ReportTypeCodeUIDTOV0 = {
    _2: '2' as ReportTypeCodeUIDTOV0,
    _3: '3' as ReportTypeCodeUIDTOV0,
    _4: '4' as ReportTypeCodeUIDTOV0
};

